/**
 * FancyLink Component
 *
 * Styled link with underline animation.
 * Handles internal and external links automatically.
 *
 * @param {object} props
 * @param {string} props.href - Link URL
 * @param {string} props.target - Link target
 * @param {string} props.className - Additional class names
 * @param {React.ReactNode} props.children - Link content
 */

import React from "react";
import { Link } from "gatsby";
import * as styles from "./FancyLink.module.scss";

const FancyLink = ({ href, target, className = "", children, ...props }) => {
  const classNames = [styles.link, className].filter(Boolean).join(" ");

  // External link or mailto/tel
  if (
    href?.startsWith("http") ||
    href?.startsWith("mailto:") ||
    href?.startsWith("tel:")
  ) {
    return (
      <a
        href={href}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        className={classNames}
        {...props}
      >
        <span>{children}</span>
      </a>
    );
  }

  // Anchor link
  if (href?.startsWith("#")) {
    return (
      <a href={href} className={classNames} {...props}>
        <span>{children}</span>
      </a>
    );
  }

  // Internal link
  return (
    <Link to={href || "/"} className={classNames} {...props}>
      <span>{children}</span>
    </Link>
  );
};

export default FancyLink;
